export function cloneData(data) {
    return data.map(function (item) { return Object.assign({}, item); });
}
